import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';

import {
    AdaptiveType,
    SearchFormAdaptiveType,
    PostFiltersAdaptiveType,
    ReviewsAdaptiveType,
    HotelRoomsAdaptiveType
} from '../models/adaptive';

import { w620, w984, w768, w512, w1024, w960, w1232 } from '../consts/adaptive';


export function getAdaptiveType(scrollWidth: number = 0): AdaptiveType {
    if (!canUseDOM) {
        return AdaptiveType.Unknown;
    }

    const width = document.documentElement.clientWidth + scrollWidth;

    if (width >= w1024) {
        return AdaptiveType.MoreThan1024;
    }

    if (width >= w960) {
        return AdaptiveType.MoreThan960;
    }

    if (width >= w768) {
        return AdaptiveType.MoreThan768;
    }

    return AdaptiveType.LessThan768;
}

export function getSearchFormAdaptiveType(scrollWidth: number = 0): SearchFormAdaptiveType {
    if (!canUseDOM || !document || !document.documentElement) {
        return SearchFormAdaptiveType.Unknown;
    }

    const width = document.documentElement.clientWidth + scrollWidth;

    if (width >= w768) {
        return SearchFormAdaptiveType.MoreThan768;
    }

    return SearchFormAdaptiveType.LessThan768;
}


export function getPostFiltersAdaptiveType(scrollWidth: number = 0): PostFiltersAdaptiveType {
    if (!canUseDOM) {
        return PostFiltersAdaptiveType.Unknown;
    }

    const width = document.documentElement.clientWidth + scrollWidth;

    if (width >= w768) {
        return PostFiltersAdaptiveType.MoreThan768;
    }

    return PostFiltersAdaptiveType.LessThan768;
}


export function getReviewsAdaptiveType(scrollWidth: number = 0): ReviewsAdaptiveType {
    if (!canUseDOM) {
        return ReviewsAdaptiveType.Unknown;
    }

    const width = document.documentElement.clientWidth + scrollWidth;

    if (width >= w984) {
        return ReviewsAdaptiveType.MoreThan984;
    }

    if (width >= w768) {
        return ReviewsAdaptiveType.MoreThan768;
    }

    if (width >= w620) {
        return ReviewsAdaptiveType.MoreThan620;
    }

    if (width >= w512) {
        return ReviewsAdaptiveType.MoreThan512;
    }

    return ReviewsAdaptiveType.LessThan512;
}

export function getHotelRoomsAdaptiveType(scrollWidth: number = 0): HotelRoomsAdaptiveType {
    if (!canUseDOM) {
        return HotelRoomsAdaptiveType.Unknown;
    }

    const width = document.documentElement.clientWidth + scrollWidth;

    if (width >= w1232) {
        return HotelRoomsAdaptiveType.MoreThan1232;
    }
    if (width < w768) {
        return HotelRoomsAdaptiveType.LessThan768;
    }

    return HotelRoomsAdaptiveType.Tablet768_960;
}

export function getScrollWidth(): number {
    const div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';

    document.body.appendChild(div);
    const scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollWidth;
}
